import React, { useState, useEffect, useContext } from "react";
import { Typography } from "@mui/material";
import { ContentBox } from '../../libs/theme';
import { getText } from "../../libs/utils";
import { styled } from '@mui/material/styles';
import { UserDataContext } from "../../App";

const MyContentBox = styled(ContentBox)(({ theme }) => ({
  maxWidth: '680px',
  margin: '0 auto',
  textAlign: 'center',
  padding: '35px 100px 35px',
  minHeight: '620px',
  display: 'flex',
  justifyContent: 'center',
  flexFlow: 'column',
  alignItems: 'center',
  [theme.breakpoints.only('md')]: {
    padding: '0px 95px',
    minHeight: '535px'
  },
  [theme.breakpoints.only('sm')]: {
    padding: '0px 106px',
    minHeight: '516px'
  },
  [theme.breakpoints.only('xs')]: {
    padding: '26px 28px',
    minHeight: '435px'
  },
}));

const TechBreak = (props) => {
  const [time, setTime] = useState(props.workTimeout);
  const {lang} = useContext(UserDataContext);

  useEffect(() => {
    const interval = setInterval(() => setTime(time => time - 1), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (lang !== '') {
      props.setGreenScreen(false);
    }
  }, [lang]);

  var seconds = time % 60;
  const minutes = (time - seconds) / 60;

  if (("" + seconds).length == 1) {
    seconds = "0" + seconds;
  }

  let timer = "";

  if (time > 0) {
    timer = `${minutes}:${seconds}`;
  }

  return (
    <MyContentBox>
      {props.mode == 1 ? (<>
        <img src="/techbrake.jpg" alt="" />
        <Typography variant="h3" sx={{ margin: '36px 0 10px', fontWeight: 600 }}>{getText('tehnopauseHead')}</Typography>
        <Typography>{getText('tehnopauseWorkTime')}</Typography>
      </>

      ) : (<>
        <img src="/sleep.jpg" alt="" />
        <Typography variant="h3" sx={{ margin: '35px 0 10px', fontWeight: 600 }}>{getText('sleepWorkTime')}</Typography>
        <Typography>{getText('sleeppauseWorkTime')}</Typography>
      </>
      )}
      {props.breakText && <Typography sx={{ color: 'secondary.main', margin: '15px 0 25px' }}>{props.breakText}</Typography>}
      {
        props.workTimeout != 0 && <>
          <Typography variant="greyCaption">{getText('willWorkThrough')}</Typography>
          <Typography variant="orderId" sx={{ margin: '10px 0 0', fontSize: '40px' }}>{timer}</Typography>
        </>
      }
    </MyContentBox>
  )
}

export default TechBreak;